import { Injectable, Inject } from "@angular/core";
import { StorageService } from "../services/storage.service";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { UserService } from "../services/user.service";
import { UserModel } from "../models/user.model";

@Injectable()
export class UserResolver implements Resolve<UserModel> {

    constructor(
        private service: UserService
    ) { }

    resolve(route: ActivatedRouteSnapshot) {
        let id = route.params['id'] as string;
        if (id.toUpperCase() == 'NEW') {
            return Promise.resolve(new UserModel);
        }

        return this.service.get(id);
    }
}
